import {Injectable} from '@angular/core'
import {Router} from '@angular/router'
import {auth} from 'firebase/app'
import {firebase} from '@firebase/app'
import {AngularFireAuth} from '@angular/fire/auth'
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/firestore'
import {Observable, of} from 'rxjs'
import {switchMap} from 'rxjs/operators'

interface User {
  uid: string
  email: string
  photoURL?: string
  displayName?: string
  favoriteColor?: string
  userType?: string
  emailVerified?: boolean
  endSuscription?: Date
}

@Injectable({providedIn: 'root'})
export class AuthService {
  user$: Observable<User>
  uid: string
  authState: any = null
  user: User

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router
  ) {
    // Get the auth state, then fetch the Firestore user document or return null
    this.user$ = this.afAuth.authState.pipe(
      switchMap(user => {
        this.authState = user
        // Logged in
        if (user) {
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges()
        } else {
          // Logged out
          return of(null)
        }
      })
    )
  }

  getUser() {
    if (this.user) {
      return this.user
    }
    return this.user$.subscribe(user => {
      this.user = user
      return user
    })
  }
  async googleSignin() {
    const provider = new auth.GoogleAuthProvider()
    const credential = await this.afAuth.auth.signInWithPopup(provider)
    this.router.navigate(['/home'])
    return this.updateUserData(credential.user)
  }

  private updateUserData(user) {
    // Sets user data to firestore on login
    const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`)

    const data = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL
      //userType:'free'
    }

    return userRef.set(data, {merge: true})
  }
  private updateUserProfile(user, userData) {
    console.log("entro a crear profile");
    const id = this.afs.createId();
    const userRef: AngularFirestoreDocument<User> = this.afs.doc('users/'+user.uid+'/profile/'+id);
    userData.userType="free";
    return userRef.set(userData, { merge: true })
  }
  private updateRegisterData() {}

  async signOut() {
    await this.afAuth.auth.signOut()
    this.uid = ''
    this.router.navigate(['/auth/login'])
  }
  getUid(): string {
    return this.uid
  }
  get authenticated(): boolean {
    return this.authState !== null
  }
  async emailSignUp(userData) {
    try {
      const credential = await this.afAuth.auth.createUserWithEmailAndPassword(
        userData.email,
        userData.password
      )
      this.SendVerificationMail()
      await this.updateUserData(credential.user)
      delete userData.password
      delete userData.confirmPassword
      return await this.updateUserProfile(credential.user, userData)
    } catch (error) {
      if (error.code === 'auth/email-already-in-use')
        return {message: 'The email address is already in use by another account.'}
      else return {message: 'Error creating account, please check your connection.'}
    }

   }
   SendVerificationMail() {
     return this.afAuth.auth.currentUser.sendEmailVerification()
     .then(() => {
     })
   }
   async resetPassword(emailAddress) {
     let a = await this.afAuth.auth.sendPasswordResetEmail(emailAddress).then(function() {
        return "e-mail sent"
      }).catch(function(error) {
        return error
      });
      console.log(a);
      return a
   }
  async emailSignin(data) {
    try {
      await this.afAuth.auth.signInWithEmailAndPassword(data.email, data.password)

      if (this.authenticated && this.afAuth.auth.currentUser.emailVerified) {
        this.router.navigate(['/home'])
        return 'authenticated'
      } else if (this.authenticated) {
        return 'noemailverified'
      } else {
        return 'error'
      }
    } catch (error) {
      return 'error'
    }
  }

  updateUserPlan(user) {
    // Sets user data to firestore on login
    const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`)
    let date = new Date()
    date.setDate(date.getDate() + 10)

    const data = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      userType: user.userType,
      endSuscription: date
    }

    return userRef.set(data, {merge: true})
  }

  //    emailLogin(credentials: EmailPasswordCredentials): firebase.Promise<FirebaseAuthState> {
  //    return this.afAuth.auth.login(credentials,
  //      { provider: AuthProviders.Password,
  //        method: AuthMethods.Password
  //       })
  //      .then(() => console.log("success"))
  //      .catch(error => console.log(error));
  // }
}
